import { useUserStore } from '@/stores/user';

function hasAccess(requiredPermission) {
  const userStore = useUserStore();

  if (Array.isArray(requiredPermission)) {
    return requiredPermission.some((permission) => userStore.hasPermission(permission));
  }

  return userStore.hasPermission(requiredPermission);
}

function updateVisibility(el, requiredPermission) {
  el.style.display = hasAccess(requiredPermission) ? '' : 'none';
}

export const canDirective = {
  mounted(el, binding) {
    updateVisibility(el, binding.value);
  },
  updated(el, binding) {
    updateVisibility(el, binding.value);
  },
};
